import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "radio-container" }
const _hoisted_2 = { class: "comment" }
const _hoisted_3 = { class: "input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_ModalCard, {
            onCancel: this.refuseCancel,
            activeValidate: _ctx.refuseSelected !== null,
            headerTitle: _ctx.$t('devis.modal.refuse.title', { id: _ctx.id }),
            onConfirm: this.refuseConfirm
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('devis.modal.refuse.precise')), 1),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = () => this.selectRefuse('SANS_SUITE')),
                  class: "radioField"
                }, [
                  _createVNode(_component_RadioBox, {
                    selected: _ctx.refuseSelected === 'SANS_SUITE'
                  }, null, 8, ["selected"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('devis.modal.refuse.projectAbandonned')), 1)
                ]),
                _createElementVNode("span", {
                  onClick: _cache[1] || (_cache[1] = () => this.selectRefuse('PERDU')),
                  class: "radioField"
                }, [
                  _createVNode(_component_RadioBox, {
                    selected: _ctx.refuseSelected === 'PERDU'
                  }, null, 8, ["selected"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('devis.modal.refuse.anotherSuccessfulOffer')), 1)
                ]),
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = () => this.selectRefuse('NEGOTIATION')),
                  class: "radioField"
                }, [
                  _createVNode(_component_RadioBox, {
                    selected: _ctx.refuseSelected === 'NEGOTIATION'
                  }, null, 8, ["selected"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('devis.modal.refuse.askNewVersion')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('devis.modal.refuse.titleComment')), 1),
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("textarea", {
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDescriptionFocus(false))),
                    onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleDescriptionFocus(true))),
                    name: "descriptif",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.commentValueModel) = $event)),
                    id: "descriptif",
                    cols: "30",
                    rows: "7",
                    maxlength: "4000"
                  }, null, 544), [
                    [_vModelText, _ctx.commentValueModel]
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["label", _ctx.commentValue || this.commentFocus ? 'active-label' : ''])
                  }, _toDisplayString(_ctx.$t('devis.modal.refuse.labelComment')), 3)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onCancel", "activeValidate", "headerTitle", "onConfirm"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}